import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_MAIN_API_BASE || 'http://localhost:4000/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('user_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;